import { useState } from "react"
import AddPopUpRegistrationForm from "../Modal/RegistrationForm"
import { useNavigate, useSearchParams } from "react-router-dom"
import { ContractOfInsurance } from "./LearningAndDevelopment/Principles/ContractOfInsurance"
import { UtmostGoodFaith } from "./LearningAndDevelopment/Principles/UtmostGoodFaith"
import { Indemnity } from "./LearningAndDevelopment/Principles/Indemnity"
import { InsurableInterest } from "./LearningAndDevelopment/Principles/InsurableInterest"
import { Contribution } from "./LearningAndDevelopment/Principles/Contribution"
import { Subrogation } from "./LearningAndDevelopment/Principles/Subrogation"
import { ReturnOfPremium } from "./LearningAndDevelopment/Principles/ReturnOfPremium"

export const Principles = ({ SubName, BtnShow }) => {
    const navigate = useNavigate()
    // /RegistrationForm
    const [addPopUpRegistrationForm, setPopUpRegistrationForm] = useState(
        {
            show: false,
            routeName: "",
        }
    )
    const [searchparams] = useSearchParams()

    const handleRegistrationForm = (True, data, name) => {
        setPopUpRegistrationForm({
            show: True,
            routeName: data,
        })
    }
    const handleRegistrationFormClose = () => {
        setPopUpRegistrationForm({
            show: false,
            routeName: "",
        })
    }
    const Name = searchparams.get('Name')


    // const [show, setShow] = useState(1);

    console.log("BtnShow", BtnShow)

    return (
        <>


                {BtnShow == 1 &&
                    <ContractOfInsurance />
                }

                {BtnShow == 7 &&
                    <UtmostGoodFaith />
                }

                {BtnShow == 6 &&
                    <Indemnity />
                }

                {BtnShow == 2 &&
                    <InsurableInterest />
                }

                {BtnShow == 3 &&
                    <Contribution />
                }

                {BtnShow == 4 &&
                    <Subrogation />
                }

                {BtnShow == 5 &&
                    <ReturnOfPremium />
                }




            {/* <div className="row p-2 p-lg-5" >

                <div className="col-12 col-lg-4 py-3">
                    <div className="p-4 faint height_All" style={{ position: 'relative' }}>
                        <img src="Static/Assets/Img/Banner/1.png" className="mb-3" alt="" style={{ width: '60px' }} />
                        <h5 className="fw-bold gray_color">CONTRACT OF INSURANCE</h5>
                        <p>Insurance is a contract between the two parties i.e. the Insurance Company and the Assured and hence all the ordinary rules of the contract that is, offer, acceptance, consideration are applicable to the Insurance contract. </p>
                        <p className="float-end" style={{ position: 'absolute', bottom: '0px', right: '30px' }}>
                            <button class="btn button"
                                onClick={() => navigate(`/ContractOfInsurance?ScreenName=Contract Of Insurance&Name=Services&SubName=Learning And Development`)}
                            ><span> Read More </span></button> </p>
                    </div>
                </div>

                <div className="col-12 col-lg-4 py-3">
                    <div className="p-4 faint height_All" style={{ position: 'relative' }}>
                        <img src="Static/Assets/Img/Banner/2.png" className="mb-3" alt="" style={{ width: '60px' }} />
                        <h5 className="fw-bold gray_color">UTMOST GOOD FAITH</h5>
                        <p>By peculiar nature of the Insurance Contract, the Insurer does not have the same level of knowledge about the subject matter to be insured as the Proposer has & hence the proposer should disclose all the material facts about the subject matter to the Insurer.  </p>
                        <p className="float-end" style={{ position: 'absolute', bottom: '0px', right: '30px' }}>
                            <button class="btn button "
                                onClick={() => navigate(`/UtmostGoodFaith?ScreenName=Utmost Good Faith&Name=Services&SubName=Learning And Development`)}
                            ><span> Read More </span></button> </p>
                    </div>
                </div>

                <div className="col-12 col-lg-4 py-3">
                    <div className="p-4 faint height_All" style={{ position: 'relative' }}>
                        <img src="Static/Assets/Img/Banner/3.png" className="mb-3" alt="" style={{ width: '60px' }} />
                        <h5 className="fw-bold gray_color">INDEMNITY</h5>
                        <p>Definition of “Indemnity” is Security against loss or damage. In the insurance context it to place the assured as far as possible in the same financial position as he was before the loss of the subject matter insured. </p>
                        <p className="float-end" style={{ position: 'absolute', bottom: '0px', right: '30px' }}>
                            <button class="btn button "
                                onClick={() => navigate(`/INDEMNITY?ScreenName=INDEMNITY&Name=Services&SubName=Learning And Development`)}
                            >
                                <span> Read More </span></button> </p>
                    </div>
                </div>

                <div className="col-12 col-lg-4 py-3">
                    <div className="p-4 faint height_All" style={{ position: 'relative' }}>
                        <img src="Static/Assets/Img/Banner/4.png" className="mb-3" alt="" style={{ width: '60px' }} />
                        <h5 className="fw-bold gray_color">INSURABLE INTEREST</h5>
                        <p>Person may be at loss by destruction of the subject matter only when he has some relationship, legal or equitable with the subject matter insured so that he may be benefitted by the safety of it or incur the loss or liability in case of loss or damage to it. </p>
                        <p className="float-end" style={{ position: 'absolute', bottom: '0px', right: '30px' }}>
                            <button class="btn button "
                                onClick={() => navigate(`/InsurableInterest?ScreenName=Insurable Interest&Name=Services&SubName=Learning And Development`)}
                            >
                                <span> Read More </span></button> </p>
                    </div>
                </div>

                <div className="col-12 col-lg-4 py-3">
                    <div className="p-4 faint height_All" style={{ position: 'relative' }}>
                        <img src="Static/Assets/Img/Banner/5.png" className="mb-3" alt="" style={{ width: '60px' }} />
                        <h5 className="fw-bold gray_color">CONTRIBUTION</h5>
                        <p>Fundamental Principle of Indemnity precludes the assured to profit out of his loss by arranging the over insurance by way of double insurance.  </p>
                        <p className="float-end" style={{ position: 'absolute', bottom: '0px', right: '30px' }}>
                            <button class="btn button "
                                onClick={() => navigate(`/Contribution?ScreenName=Contribution&Name=Services&SubName=Learning And Development`)}
                            >
                                <span> Read More </span></button> </p>
                    </div>
                </div>

                <div className="col-12 col-lg-4 py-3">
                    <div className="p-4 faint height_All" style={{ position: 'relative' }}>
                        <img src="Static/Assets/Img/Banner/6.png" className="mb-3" alt="" style={{ width: '60px' }} />
                        <h5 className="fw-bold gray_color">SUBROGATION</h5>
                        <p>Fundamental Principle of Indemnity do not allow the assured to recover his loss under the policy and also from the person liable for such loss and thus gain out of his loss.</p>
                        <p className="float-end" style={{ position: 'absolute', bottom: '0px', right: '30px' }}>
                            <button class="btn button "
                                onClick={() => navigate(`/Subrogation?ScreenName=Subrogation&Name=Services&SubName=Learning And Development`)}
                            >
                                <span> Read More </span></button>   </p>
                    </div>
                </div>

                <div className="col-12 col-lg-4 py-3">
                    <div className="p-4 faint height_All" style={{ position: 'relative' }}>
                        <img src="Static/Assets/Img/Banner/7.png" className="mb-3" alt="" style={{ width: '60px' }} />
                        <h5 className="fw-bold gray_color">RETURN OF PREMIUM</h5>
                        <p>Underwriter receives the premium as a consideration under the contract of insurance for running the risk of indemnifying the assured, if he does not run the risk he ought to return the premium. Failure of consideration is where no risk attaches at all. </p>
                        <p className="float-end" style={{ position: 'absolute', bottom: '0px', right: '30px' }}>
                            <button class="btn button "
                                onClick={() => navigate(`/ReturnOfPremium?ScreenName=Return Of Premium&Name=Services&SubName=Learning And Development`)}
                            >
                                <span> Read More </span></button> </p>
                    </div>
                </div>

            </div> */}
            {/* {addPopUpRegistrationForm.show ?
                <AddPopUpRegistrationForm
                    addPopUpRegistrationForm={addPopUpRegistrationForm}
                    heading="Registration Form"
                    cancelBtnCallBack={handleRegistrationFormClose}
                    SubName={SubName}
                /> : <></>
            } */}

        </>
    )
}
